module.exports = __webpack_public_path__ + "img/apple.865381e0.svg";